import React, { useState, useEffect, useReducer, useMemo, Reducer } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'

//@ts-ignore
import Modal from 'live/components/ui/Modal'
import SpreadSheetOption from '../options/SpreadsheetOptions'
import getDatabase from '../../../actionCreators/getDatabaseHeaders'
import selectSheet from '../../../actionCreators/selectSheet'
import dismissModal from '../../../actionCreators/dismissModal'
import updateDatabase from '../../../actionCreators/updateDatabase'

// components preview
import ModalPreview from '../../preview/ModalPreview'
import ModalHistoryPreview from '../options/model/edit/ModalHistoryPreview'
//@ts-ignore
import PerspectiveSelect from 'live/components/forms/ui/perspective-select'
//@ts-ignore
import i18n from 'live/services/i18n'
// @ts-ignore
import ActionToggle from 'live/components/ui/action-toggle'
import ListFiles from '../options/model/edit/ListFiles'
import Settings from '../options/model/edit/Settings'
import { previewFile } from '../../../api/preview/edit/previewFile'
import { TemplateHeaderPreview, Database } from '../options/model/types'
import { FileHistory } from '../options/model/edit/BaseListFiles'
import { LoadingIconCenter } from '../../main'
import { DEFAULT_DATASOURCE } from '../../../lib/constants'
import getDatabaseHeaders from '../../../api/getDatabaseHeaders'
import { Pill } from '../../controllers/Pill'
import { GeneralInformation } from '../../CreateDatabase/GeneralInformation'
import { Moments, State, MomentState } from './type'
import { reducer, DEFAULT_STATE } from './reducer'
import List from '../options/model/edit/rules/List'
import { getOptions, rules } from '../options/model/edit/rules'
import { ApplyRule } from '../options/model/edit/rules/type'
// import './modalFull.css'
// import'../../preview/preview.scss'
import '../options/model/edit/rules/init'
interface Props {
    model: string
    getDatabase?: React.FC
    showModalDatabase: boolean
    headers: any[]
    dismissModal: React.FC
    setDropDown?: any
    // updatedSuccessfully: boolean
    database: Database
    updateDatabase(any): React.FC
    open: (type: string) => void
    hide: () => void
    show: boolean
    setParam: (param: string) => void
    param?: string
}
interface PropParam {
    page: Page
}
enum Page {
    GENERAL_INFORMATION,
    SETTINGS,
    RULES
}

function convertToParam(param: string): PropParam {
    if (!param || param.length < 2) {
        return {
            page: Page.GENERAL_INFORMATION
        }
    }
    try {
        const json = JSON.parse(param)
        const page = json['page'] || Page.GENERAL_INFORMATION
        return { page }
    } catch (error) {
        return {
            page: Page.GENERAL_INFORMATION
        }
    }
}

function paramToString(param: PropParam): string {
    return JSON.stringify(param)
}

function EditDatabase({
    model,
    getDatabase,
    showModalDatabase = false,
    dismissModal,
    setDropDown,
    // updatedSuccessfully,
    updateDatabase,
    hide,
    open,
    show,
    setParam,
    param
}: Props) {
    const hasPermissions = window.Live.authorization.permissions['CREATE_SPREADSHEET'] !== undefined

    if (!hasPermissions) {
        return null
    }

    const [loading, setLoading] = useState<boolean>(true)
    const [pageParam, setPageParam] = useState<PropParam>(convertToParam(param))
    const [template, setTemplate] = useState<TemplateHeaderPreview | undefined>()
    const [uidTemplate, setUidTemplate] = useState<string | undefined>()
    const [file, setFile] = useState<FileHistory>()

    useEffect(() => {
        const fileUid = String(file?.uid)
        const templateUid = String(template?.uid)

        if (!!file && fileUid.length > 5 && fileUid !== templateUid) {
            previewFile(fileUid).then(template => {
                if (template) {
                    setTemplate(template)
                }
            })
        }
    }, [file?.uid])

    const getSheets = (): string[] => {
        if (!!template) {
            return template.sheetData.map(({ sheetName }) => sheetName)
        }
        return [file?.sheetIndex]
    }
    const [sheetSelected, setSheet] = useState<string>(getSheets()[0])

    const [database, setDatabase] = useState<Database>(DEFAULT_DATASOURCE)

    const [state, dispatch] = useReducer<Reducer<State, Moments>>(reducer, DEFAULT_STATE)

    useEffect(() => {
        if (show) {
            if (!loading) setLoading(true)
            getDatabaseHeaders(model)
                .then((database: Database) => setDatabase(database))
                .finally(() => setLoading(false))
        } else {
            if (database.headers.length > 0) {
                setDatabase(DEFAULT_DATASOURCE)
                setTemplate(undefined)
                setFile(undefined)
            }
        }
    }, [show, model])

    useMemo(() => {
        setPageParam(() => convertToParam(param))
    }, [param, model])

    const content = useMemo(() => {
        if (loading)
            return (
                <LoadingIconCenter
                    style={{
                        display: loading ? 'inline-block' : 'none'
                    }}
                    className="fa fa-spinner fa-spin fa-4x"
                    aria-hidden="true"
                />
            )

        const modelRules = database?.rules || []

        switch (pageParam.page) {
            case Page.RULES:
                return (
                    <div
                        style={{
                            height: '450px',
                            width: '600px',
                            overflow: 'auto',
                            padding: '5px'
                        }}
                    >
                        <List
                            label="ADD SPECIAL RULE"
                            onChange={option => {
                                const rule = rules[option.value]
                                modelRules.push({
                                    applyRule: ApplyRule.Always,
                                    ruleName: option.value,
                                    props: rule.defaultProps
                                })
                                setDatabase(curr => ({
                                    ...curr,
                                    rules: modelRules
                                }))
                            }}
                            options={getOptions()}
                            value={{}}
                        />
                        {modelRules.map((modelRule, index) => {
                            const rule = rules[modelRule?.ruleName]
                            if (!rule) return null
                            const Component = rule.Component
                            return (
                                <div
                                    style={{
                                        padding: '8px',
                                        marginTop: '10px',
                                        border: 'solid 1px #c2c2c2'
                                    }}
                                >
                                    <label style={{ display: 'inline', padding: '0px 15px 0px 0px' }}>
                                        {' '}
                                        {rule.label}
                                    </label>
                                    <button
                                        className="btn btn-danger"
                                        style={{ fontSize: '12px', padding: '2px 4px' }}
                                        onClick={() => {
                                            delete modelRules[index]
                                            setDatabase(curr => ({
                                                ...curr,
                                                rules: modelRules
                                            }))
                                        }}
                                    >
                                        remove
                                    </button>
                                    <Component
                                        applyRule={modelRule.applyRule}
                                        props={modelRule.props}
                                        onChange={rule => {
                                            modelRules[index] = rule
                                            setDatabase(curr => ({
                                                ...curr,
                                                rules: modelRules
                                            }))
                                        }}
                                    />
                                </div>
                            )
                        })}
                    </div>
                )
            case Page.SETTINGS:
                return (
                    <ModalHistoryPreview
                        model={database}
                        headers={database.headers}
                        onlyView={false}
                        update={true}
                        database={database.databaseName}
                        file={file}
                        getHeader={true}
                        sheets={getSheets()}
                        templete={template}
                        setSheet={setSheet}
                        sheetSelected={sheetSelected}
                        setDatabase={currDatabase => {
                            setDatabase(currDatabase)
                        }}
                    />
                )
            default:
                return (
                    <div>
                        <GeneralInformation
                            isValid={state.isValidGeneralInformation}
                            setIsValid={isValid =>
                                dispatch({
                                    type: MomentState.VALID_MAIN_CONTENT_GENERAL_INFORMATION,
                                    isValid
                                })
                            }
                            database={database}
                            setDatabase={setDatabase}
                        />
                    </div>
                )
        }
    }, [database, loading, file, pageParam, sheetSelected, model])

    return (
        <li
            onClick={() => {
                if (!show) open(model)
            }}
        >
            <SpreadSheetOption
                icon="cog"
                text={i18n('Database Configuration')}
                onClick={() => {
                    // getDatabase(model)
                    // handleShow()
                }}
            />
            {show ? (
                <Modal
                    show={show}
                    onHide={hide}
                    onClose={hide}
                    backdrop="static"
                    keyboard={false}
                    className="showDatabase2"
                >
                    <Modal.Header style={{ backgroundColor: 'var(--gray-100)', height: '130px', padding: '20px' }} closeButton>
                        <div>
                            <Pill
                                label="General Information"
                                onClick={() => {
                                    setParam(
                                        paramToString({
                                            page: Page.GENERAL_INFORMATION
                                        })
                                    )
                                }}
                                selected={pageParam.page == Page.GENERAL_INFORMATION}
                            />
                            <Pill
                                label="Settings"
                                onClick={() => {
                                    setParam(
                                        paramToString({
                                            page: Page.SETTINGS
                                        })
                                    )
                                }}
                                selected={pageParam.page == Page.SETTINGS}
                            />
                            <Pill
                                label="Rules"
                                onClick={() => {
                                    setParam(
                                        paramToString({
                                            page: Page.RULES
                                        })
                                    )
                                }}
                                selected={pageParam.page == Page.RULES}
                            />
                            <div
                                style={{
                                    width: '300px',
                                    padding: '8px'
                                }}
                            >
                                <ListFiles collection={database?.eventType} onChange={setFile} select={file} />
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body style={{ height: '90%' }}>{content}</Modal.Body>
                    <Modal.Footer>
                        <StyledButtons>
                            <button
                                className="save"
                                disabled={false}
                                onClick={() => {
                                    updateDatabase(database)
                                    hide()
                                }}
                            >
                                {i18n('Save')}
                            </button>
                            <button
                                className="save"
                                disabled={false}
                                onClick={() => {
                                    updateDatabase(database)
                                    const fileAux = { ...file }
                                    setFile({
                                        ...file,
                                        uid: ''
                                    })
                                    setTimeout(() => {
                                        setFile(fileAux)
                                    }, 500)
                                }}
                            >
                                {i18n('Save and Reload')}
                            </button>
                            <button className="cancel" onClick={hide}>
                                {i18n('Cancel')}
                            </button>
                        </StyledButtons>
                    </Modal.Footer>
                </Modal>
            ) : null}
        </li>
    )
}

const ModalTitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 100%;
`
const InputArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    label {
        white-space: nowrap;
        margin-right: 7px;

        &::after {
            content: ' *';
            color: red;
        }
    }
    input {
        width: 216px;
    }
`

const ToggleArea = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-left: 7px;
    height: 100%;
    label {
        white-space: nowrap;
        margin-right: 7px;
        margin-left: 4px;
    }
    a {
        top: 0 !important;
    }
    div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`

const PerspectiveContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    & .live-select {
        display: flex;
        flex-direction: row;
        label {
            margin-right: 7px;
            height: min-content;
            align-self: center;
        }
    }
    & .form-group {
        margin: 0 !important;
    }
    & .Select-control {
        width: 200px;
    }
`
const StyledButtons = styled.div`
    .save {
        background: var(--blue-500);
        color: var(--gray-0);
        border-radius: 3px;
        font-size: 15px;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        padding: 8px 24px;
        border: none;
        line-height: 16px;
        margin-left: 16px;
        :disabled {
            background: var(--gray-300);
        }
    }
    .cancel {
        color: var(--gray-800);
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        background: var(--gray-0);
        font-size: 15px;
        border: 1px solid var(--gray-300);
        border-radius: 3px;
        font-weight: 600;
        padding: 8px 24px;
        line-height: 16px;
        margin-left: 10px;
    }
`
function mapStateToProps({ sheet }) {
    const { headers, database, showModalDatabase, updatedSuccessfully } = sheet

    return {
        headers,
        database,
        showModalDatabase
    }
}

export default connect(mapStateToProps, { selectSheet, getDatabase, dismissModal, updateDatabase })(EditDatabase)
